import { useCallback } from "react";

import CommonPagination from "../CommonPagination";

function DefaultBottomToolbar({ instance, enabledRowSelection }) {
  const {
    setPageSize,
    gotoPage,
    selectedFlatRows,
    rows,

    state: { pageSize, pageIndex },
    manualPagination,
    totalRows,
  } = instance;

  const handleGetNewPage = useCallback(
    (newPage) => {
      if (newPage === pageIndex) {
        return;
      }

      gotoPage(newPage);
    },
    [pageIndex, gotoPage],
  );

  return (
    <div className="tw-pt-3 tw-px-2 tw-relative tw-flex tw-flex-col md:tw-flex-row">
      <div>
        <CommonPagination
          totalItems={manualPagination ? totalRows : rows.length}
          initialItemsPerPage={pageSize}
          initialPage={pageIndex}
          handleGetDataPageSize={(pageSize) => {
            setPageSize(pageSize);
          }}
          handleGetNewPage={handleGetNewPage}
        />
      </div>

      {enabledRowSelection && (
        <div
          className={`${
            selectedFlatRows?.length === 0 ? "tw-w-0" : ""
          } md:tw-absolute md:tw-text-xl md:tw-mr-2 md:tw-text-right md:tw-mt-0 tw-mt-2 tw-flex-1 tw-text-left tw-right-0 tw-text-base tw-overflow-hidden tw-transition-all tw-duration-300 tw-ease-in-out`}
        >
          {selectedFlatRows?.length} of {rows?.length} row(s) selected
        </div>
      )}
    </div>
  );
}

export default DefaultBottomToolbar;
